import { RightColumn } from "../components/RightColumn"

/**
 * Component for managing ecographic reports in the right column of the application.
 * This is a wrapper around the unified RightColumn component.
 *
 * @param {Object} props - Component props
 * @returns {JSX.Element} The RightColumnEcograph component
 */
export const RightColumnEcograph = (props) => {
  return <RightColumn {...props} reportType="ecograph" />
}

export default RightColumnEcograph
